// The client's copy verbatim, bar the five URLs and the intro — everything still
// waiting on them keeps `_placeholder_` in its id.
export default {
  intro: {
    id: 'rm_footer_press_kit_placeholder_intro',
    defaultMessage:
      "Here you'll find all the information you need around the Mine my Phone educational platform.",
  },
  releaseLabel: {
    id: 'rm_footer_press_kit_release_label',
    defaultMessage: 'Press Release',
  },
  releaseUrl: {
    id: 'rm_footer_press_kit_placeholder_release_url',
    defaultMessage: 'https://example.com/press/mine-my-phone-release',
  },
  expertsLabel: {
    id: 'rm_footer_press_kit_experts_label',
    defaultMessage: 'Expert Profiles',
  },
  expertsDescription: {
    id: 'rm_footer_press_kit_experts_description',
    defaultMessage: 'Biographies, Official Headshots',
  },
  expertsUrl: {
    id: 'rm_footer_press_kit_placeholder_experts_url',
    defaultMessage: 'https://example.com/press/mine-my-phone-experts',
  },
  reportLabel: {
    id: 'rm_footer_press_kit_report_label',
    defaultMessage: 'Global Consumer Report',
  },
  reportDescription: {
    id: 'rm_footer_press_kit_report_description',
    defaultMessage: 'Data, Infographics…',
  },
  reportUrl: {
    id: 'rm_footer_press_kit_placeholder_report_url',
    defaultMessage: 'https://example.com/press/mine-my-phone-report',
  },
  faqLabel: {
    id: 'rm_footer_press_kit_faq_label',
    defaultMessage: 'FAQ',
  },
  faqUrl: {
    id: 'rm_footer_press_kit_placeholder_faq_url',
    defaultMessage: 'https://example.com/press/mine-my-phone-faq',
  },
  visualsLabel: {
    id: 'rm_footer_press_kit_visuals_label',
    defaultMessage: 'Visual Assets',
  },
  visualsDescription: {
    id: 'rm_footer_press_kit_visuals_description',
    defaultMessage: 'Photos and video files',
  },
  visualsUrl: {
    id: 'rm_footer_press_kit_placeholder_visuals_url',
    defaultMessage: 'https://example.com/press/mine-my-phone-visuals',
  },
  contactTitle: {
    id: 'rm_footer_press_kit_contact_title',
    defaultMessage: 'More questions?',
  },
  contactBody: {
    id: 'rm_footer_press_kit_contact_body',
    defaultMessage:
      'Contact us at [press@backmarket.com](mailto:press@backmarket.com)',
  },
} as const
